var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getIsOpen)?_c('div',{staticClass:"modal-backdrop"},[_c(_vm.getComponent,_vm._b({ref:"modal",tag:"component",on:{"close":_vm.closeModal}},'component',_vm.getProps,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }